import './manage.component.scss'

import $ from 'jquery'

$(document).ready(function () {
  const $manageItem = $('.manage-item');
  if ($manageItem.length > 0) {
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      const offsets = {
        first: scrollTop + $(window).height() * .3,
        last: scrollTop + $(window).height() * .7,
      };
      if ($(this).width() <= 768) {
        offsets.first = scrollTop + $(window).height() * .5;
        offsets.last = scrollTop + $(window).height() * .95;
      }
      $manageItem.each(function () {
        const $item = $(this);
        const itemOffset = $item.offset().top + $item.height() * .5;
        if (itemOffset > offsets.first && itemOffset < offsets.last) {
          if ($('.manage-item__title--active').length === 0) {
            $item.find('.manage-item__title').addClass('manage-item__title--active');
          }
        } else {
          $item.find('.manage-item__title').removeClass('manage-item__title--active');
        }
      });

    }).trigger('scroll');
  }
});